import { forwardRef, MutableRefObject } from 'react';

import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import { AddToCart } from '@/productDiscovery/ProductPage/common/components/AddToCart/AddToCart';
import { useShowStickyElements } from '@/productDiscovery/ProductPage/hooks/useShowStickyElements/useShowStickyElements';

import { useB2bPriceAdvantage } from '../../../b2b/hooks/useB2bPriceAdvantage';

export const StickyElements = forwardRef<HTMLDivElement>((_, ref) => {
  const { modelId } = useDetail();

  // TODO: Remove this call. Only used for the add2cart onclick tracking
  const b2bPriceAdvantage = useB2bPriceAdvantage(modelId) ?? 0;

  const { showStickyA2C } = useShowStickyElements(
    ref as MutableRefObject<HTMLDivElement | null>,
  );

  return (
    showStickyA2C && (
      <div data-testid="sticky-A2C-button">
        <AddToCart b2bPriceAdvantage={b2bPriceAdvantage} isSticky isRedesign />
      </div>
    )
  );
});
